<template>
<div style="width: 100%;" id="clinics">

  <!-- <div :class="[`${classId}`, { 's_active' : hasResults&&!isLoading }]"> -->

    <!-- <template v-if="!localClinics.length"> -->

      <div class="content-main l_standard l_text-center l_min-footspace">
        <!-- <p class="h2" v-if="hasSearched">No clinics found within 50km.</p> -->
        <p class="h1" v-if="localClinics.length">Your closest clinics</p>
        <p class="h1" v-else>Viewing all clinics</p>
        <!-- <p>Please try another search or</p> -->
        <!-- <a href="/clinics/directory/" class="btn">View all our clinics</a> -->
      </div>

    <!-- </template> -->

    <template v-if="showClinics.length">

      <div class="clinicview l_listing" v-for="clinic in showClinics" :key="clinic.id" :class="{ 's_active' : activeClinics.indexOf(clinic.id) !== -1, 'l_associated' : clinic.isAssociated }" :data-id="clinic.slug">
        <div class="clinicview-inner">

          <div class="clinicview-head" @click="clinicToggle(clinic.id)">
            <h3 class="clinicview-title" :class="{ 'l_reduced-size' : clinic.title.length > 30 }">
              <span v-html="clinic.title"></span>
              <div class="clinicview-title-note" v-if="clinic.isAssociated">* Associated clinic</div>
              <div class="clinicview-title-hours" v-if="clinic.hours">
                <strong v-html="openNow(clinic)"></strong>
                <span v-html="openHours(clinic)"></span>
                <span v-if="clinic.distance"><br />{{ clinic.distance }}km<nobr v-if="clinic.mapUrl"> <a :href=clinic.mapUrl target="_blank" class="clinicview-dirlink"><svg class="icon"><use href="#pin"></use></svg>Get directions</a></nobr></span>
                
              </div>
            </h3>
            <div class="clinicview-actions">
              <a :href=clinic.url class="btn l_min l_thick">More info<span data-breakmin="papa">rmation</span></a>
            </div>
          </div>

          <div class="clinicview-body">

            <div class="clinicview-info l_first">

              <div>


                <p v-if="clinic.distance"><strong>{{ clinic.distance }}km</strong> away</p>

                <p v-if="clinic.phone || clinic.fax">
                  <span v-if="clinic.phone"><strong>Call</strong> <a :href="`tel:${clinic.phone}`">{{ clinic.phone }}</a><br /></span>
                  <span v-if="clinic.fax"><strong>Fax</strong> {{ clinic.fax }}</span>
                </p>

                <p>
                  <span v-if="clinic.address1" v-html="formatAddress1(clinic.address1)"></span><br />
                  <nobr>{{ clinic.suburb }} {{ clinic.stateAbbrev }} {{ clinic.postcode }}</nobr>
                  <nobr v-if="clinic.mapUrl"><a :href=clinic.mapUrl target="_blank" class="clinicview-dirlink"> <svg class="icon"><use href="#pin"></use></svg>Get directions</a></nobr>
                </p>

                <p v-if="clinic.hours">
                  <strong v-html="openNow(clinic)"></strong><br />
                  <span v-html="openHours(clinic)"></span>
                </p>

              </div>

              <div class="clinicview-note" v-if="clinic.isAssociated">
                From this clinic, Benson Radiology provides radiologist and reporting services only
              </div>

            </div>

            <div class="clinicview-info l_second">
              <ul class="clinicview-services" v-if="clinic.services.length">
                <li><strong>Services</strong></li>
                <li v-for="service in clinic.services" v-html="service.title"></li>
              </ul>
            </div>

            <div class="clinicview-infoactions">
              <a :href=clinic.url class="btn l_min l_stretch">More information</a>
            </div>

            <div class="clinicview-aside">
              <img :src=clinic.imageUrl alt="" class="clinicview-image" v-if="clinic.imageUrl.length">
            </div>

          </div>

        </div>
      </div>

    </template>

  <!-- </div> -->

</div>
</template>

<script>
import EventBus from '../utils/event-bus';
import * as openHours from '../utils/open-hours';

export default {
  name: "Clinics",
  data() {
    return {

      hasResults: false,

      hasSearched: false,

      isEmpty: false,

      isLoading: false,

      clinics: [],

      localClinics: [],

      activeClinics: [],

      highlightedClinicId: false,

      selectedClinicId: false,

      localClinic: false

    };
  },
  props: {
    searchId: String,
    classId: {
      type: String,
      default: ''
    }
  },
  components: {
  },
  computed: {

    showClinics() {
      if (this.localClinics.length) {
        return this.localClinics;
      } else {
        return this.clinics;
      }
    }

  },
  methods: {

    deselectClinic(event) {

      // console.log('test');

      this.selectedClinicId = false;
      event.preventDefault();
      return false;

    },

    selectClinic(clinic, event) {

      // console.log(this.searchId);
      if (this.searchId == 'main') {
        this.displayClinic(clinic, event);
      } else {
        if (this.selectedClinicId == clinic.id) {
          this.selectedClinicId = false;
        } else {
          this.selectedClinicId = clinic.id;
        }
      }

      event.preventDefault();
      event.stopPropagation();
      return false;

    },

    displayClinic(clinic, event) {

      this.deselectClinic(event);

      if (this.classId == 'recclinics') {
        EventBus.$emit('CLINIC_DISPLAY', this.searchId, clinic);
        event.preventDefault();
      } else if (this.searchId == 'sidebar') {
        EventBus.$emit('LOCALCLINIC_SET', clinic);
        event.preventDefault();
      } else {
        return;
      }

    },

    highlightClinic(clinic, event) {

      EventBus.$emit('CLINIC_HIGHLIGHT', this.searchId, clinic);

    },

    unhighlightClinic(clinic, event) {

      EventBus.$emit('CLINIC_UNHIGHLIGHT', this.searchId, clinic);

    },

    openNow(clinic) {
      // return false;
      return openHours.displaySimple(clinic);
    },

    openHours(clinic) {
      // return '';
      return openHours.outlook(clinic);
    },

    formatAddress1(address1) {
      return address1.replace(', ', '<br />');
    },

    clinicToggle(clinicId) {

      if (this.activeClinics.indexOf(clinicId) !== -1) {
        this.activeClinics.splice(this.activeClinics.indexOf(clinicId), 1);
      } else {
        this.activeClinics.push(clinicId);
      }

      return true;
    }

  },
  mounted() {

    EventBus.$on('MAP_POPULATE', (searchId, locations) => {
      if (searchId == this.searchId) {
        this.localClinics = locations;
        this.isLoading = false;
        this.hasResults = true;
      }
    });

    EventBus.$on('MAP_LOADING', (searchId) => {
      if (searchId == this.searchId) {
        this.isLoading = true;
        this.hasResults = false;
      }
    });

    EventBus.$on('CLINIC_SEARCHED', (searchId, clinic) => {
      this.hasSearched = true;
    });

    EventBus.$on('CLINIC_HIGHLIGHT', (searchId, clinic) => {
      if (searchId == this.searchId) {
        this.highlightedClinicId = clinic.id;
      }
    });

    EventBus.$on('CLINIC_UNHIGHLIGHT', (searchId, clinic) => {
      if (searchId == this.searchId) {
        this.highlightedClinicId = false;
      }
    });

    EventBus.$on('LOCALCLINIC_EMIT', (clinic) => {
      this.localClinic = clinic;
    });

    // get clinics array
    if (typeof window.clinics !== 'undefined') {
      this.clinics = window.clinics;
      // console.log(this.clinics);
    }

  },
};
</script>

<style scoped>
</style>